export const SELECTOR_PRODUCT_PRICE_LIST = (state) => Object.values(state.productPriceList.productPriceList);

export const SELECTOR_PRODUCT_PRICE_LIST_TOTALS = (state) => state.productPriceList.productPriceListTotals;